import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../Store/hooks';
import { signOutAccount } from '../../Store/StudentSlices/signOutAccountSlice';
import { resetCoach } from '../../Store/StudentSlices/getCoachSlice';

const mainNav = [
  {
    label: 'Home',
    path: '/',
    match: ['/', '/home'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M3 10.5 12 3l9 7.5" />
        <path d="M5 9.5V21h14V9.5" />
        <path d="M9 21V13h6v8" />
      </svg>
    ),
  },
  {
    label: 'My Students',
    path: '/students',
    match: ['/students'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M16 11a4 4 0 1 0-8 0" />
        <path d="M12 15c-4.4 0-8 2.2-8 5v1h16v-1c0-2.8-3.6-5-8-5z" />
        <circle cx="12" cy="7" r="3" />
      </svg>
    ),
  },
  {
    label: 'Sessions',
    path: '/sessions',
    match: ['/sessions'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <path d="M16 3v4M8 3v4M3 11h18" />
        <path d="m9 16 2 2 4-4" />
      </svg>
    ),
  },
  {
    label: 'Messages',
    path: '/messages',
    match: ['/messages'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21 15a4 4 0 0 1-4 4H7l-4 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
      </svg>
    ),
  },
  {
    label: 'Resources',
    path: '/resources',
    match: ['/resources'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M4 4h6l2 3h8v13H4z" />
        <path d="M4 9h16" />
      </svg>
    ),
  },
];

const supportNav = [
  {
    label: 'Settings',
    path: '/settings',
    match: ['/settings'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a2 2 0 0 0 .4 2.1l.1.1a2 2 0 0 1-2.8 2.8l-.1-.1a2 2 0 0 0-2.1-.4 2 2 0 0 0-1.2 1.8V22a2 2 0 0 1-4 0v-.1a2 2 0 0 0-1.2-1.8 2 2 0 0 0-2.1.4l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a2 2 0 0 0 .4-2.1 2 2 0 0 0-1.8-1.2H2a2 2 0 0 1 0-4h.1a2 2 0 0 0 1.8-1.2 2 2 0 0 0-.4-2.1l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a2 2 0 0 0 2.1.4 2 2 0 0 0 1.2-1.8V2a2 2 0 0 1 4 0v.1a2 2 0 0 0 1.2 1.8 2 2 0 0 0 2.1-.4l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a2 2 0 0 0-.4 2.1 2 2 0 0 0 1.8 1.2H22a2 2 0 0 1 0 4h-.1a2 2 0 0 0-1.8 1.2z" />
      </svg>
    ),
  },
  {
    label: 'Support',
    tab: 'help-and-support',
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M8 15s1.5 2 4 2 4-2 4-2" />
        <path d="M9 9h.01M15 9h.01" />
      </svg>
    ),
  },
  {
    label: 'Sign out',
    action: 'signout',
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <path d="M16 17l5-5-5-5" />
        <path d="M21 12H9" />
      </svg>
    ),
  },
];

const SideBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const { loading: isSigningOut } = useAppSelector(
    (state) => state.signOutAccount
  );
  const { coachInfo } = useAppSelector((state) => state.getCoach);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isAccountOpen, setIsAccountOpen] = useState(false);

  const isItemActive = (match: string[]) =>
    match.some((path) =>
      path === '/' ? pathname === '/' : pathname.startsWith(path)
    );
  const normalizeTab = (value: string) =>
    value
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  const activeTab = normalizeTab(searchParams.get('tab') ?? '');
  const coach = coachInfo as any;
  const coachName =
    coach?.name 
   
 

  return (
    <aside className={`sidebar ${isCollapsed ? 'sidebar--collapsed' : ''}`}>
         <div className="sidebar-header">
         
            <h1 className="sidebar-brand">
              Coaching
            </h1>

          <button
            className="sidebar-collapse-btn"
            type="button"
            aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            onClick={() => setIsCollapsed((prev) => !prev)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <g clipPath="url(#clip0_161_18073)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.8333 2.5C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333ZM6.66667 4.16667H4.16667V15.8333H6.66667V4.16667ZM15.8333 4.16667H8.33333V15.8333H15.8333V4.16667ZM12.3275 7.64333C12.4775 7.49388 12.6787 7.4071 12.8903 7.40064C13.1019 7.39418 13.3081 7.46851 13.4669 7.60854C13.6257 7.74857 13.7253 7.94379 13.7453 8.15456C13.7654 8.36533 13.7045 8.57584 13.575 8.74333L13.5058 8.82167L12.3275 10L13.5058 11.1783C13.6569 11.328 13.745 11.5296 13.7522 11.7421C13.7594 11.9546 13.6852 12.1618 13.5446 12.3213C13.4041 12.4808 13.2078 12.5806 12.9961 12.6002C12.7844 12.6198 12.5733 12.5577 12.4058 12.4267L12.3275 12.3567L10.56 10.59C10.4164 10.4466 10.3301 10.2558 10.3172 10.0532C10.3043 9.8507 10.3657 9.65043 10.49 9.49L10.56 9.41083L12.3275 7.64333Z"
                  fill="#09244B"
                />
              </g>
              <defs>
                <clipPath id="clip0_161_18073">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
      <div className="top-nav">
       
        <nav className="sidebar-nav">
          {mainNav.map((item) => {
            const active = isItemActive(item.match);
            return (
              <button
                key={item.label}
                className={`sidebar-nav-item ${active ? 'sidebar-nav-item--active' : ''}`}
                type="button"
                onClick={() => navigate(item.path)}
              >
                <span
                  className={`sidebar-nav-icon ${active ? 'sidebar-nav-icon--active' : ''}`}
                >
                  {item.icon}
                </span>
                <span className="sidebar-nav-label">{item.label}</span>
              </button>
            );
          })}
        </nav>

       <div className="sidebar-account">
        {isAccountOpen ? (
          <div className="sidebar-support">
            {supportNav.map((item) => {
              const isSupportTab =
                pathname.startsWith('/settings') && activeTab === item.tab;
              const active = item.tab
                ? isSupportTab
                : item.match
                  ? isItemActive(item.match) && activeTab !== 'help-and-support'
                  : false;
              return (
                <button
                  key={item.label}
                  className={`sidebar-support-item ${active ? 'sidebar-support-item--active' : ''}`}
                  type="button"
                  disabled={item.action === 'signout' && isSigningOut}
                  onClick={() => {
                    if (item.tab) {
                      navigate(`/settings?tab=${item.tab}`);
                      return;
                    }
                    if (item.path) {
                      navigate(item.path);
                      return;
                    }
                    if (item.action === 'signout') {
                      dispatch(signOutAccount())
                        .unwrap()
                        .then(() => {
                          // Clear coach info from Redux
                          dispatch(resetCoach());
                          // Redirect to external accounts page after successful logout
                          window.location.href = process.env.REACT_APP_AUTH_REDIRECT || 'https://guiding-hedgehog-41.accounts.dev/sign-in';
                        })
                        .catch(() => {
                          // Even if logout fails, clear data and redirect
                          dispatch(resetCoach());
                          window.location.href = process.env.REACT_APP_AUTH_REDIRECT || 'https://guiding-hedgehog-41.accounts.dev/sign-in';
                        });
                    }
                  }}
                >
                  <span className="sidebar-support-icon">{item.icon}</span>
                  <span className="sidebar-support-label">
                    {item.action === 'signout' && isSigningOut
                      ? 'Signing out...'
                      : item.label}
                  </span>
                </button>
              );
            })}
          </div>
        ) : null}
        <button
          className={`sidebar-account-toggle ${isAccountOpen ? 'sidebar-account-toggle--open' : ''}`}
          type="button"
          aria-expanded={isAccountOpen}
          onClick={() => setIsAccountOpen((prev) => !prev)}
        >
          <div className="sidebar-account-left">
            <div className="sidebar-avatar" />
            <div className="sidebar-name">
              <p className="sidebar-user-name">{coachName}</p>
              <p className="sidebar-user-role">Coach</p>
            </div>
          </div>
          <svg
            className="sidebar-account-icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>
      </div>
      </div>

    
    </aside>
  );
};

export default SideBar;
